alt = require 'alt'
Button = require 'components/common/button'
EtdStore = require 'stores/etd_store'
EtdActions = require 'actions/etd_actions'
Modal = require 'components/common/modal'
DetailedJudgements = require './detailed_judgements'
OptionsList = require 'components/common/options_list'
{ useI18n } = require 'lib/react_utils'
{ useState } = React
{ RadioButtonList } = ReactComponents

RegularJudgment = ({
  criterion,
  criticalOutcomes
  editable,
  isConsensus,
  noAutoSave,
  onJudgementChange,
  questionType,
  readOnly,
  renderMode,
  sectionId,
  sectionName,
  selectedOption,
  templateId,
}) ->
  i18n = useI18n('es:recommendations.table')
  criterionDescription = criterion.get('description')
  additionalOptions = criterion.get('additionalOptions', Immutable.List())
  details = criterion.get('details')
  options = criterion.get('options', Immutable.List())

  [isModalOpen, setIsModalOpen] = useState(false)
  [etdStoreSnapshot, setEtdStoreSnapshot] = useState(null)

  openModal = ->
    return if readOnly or not editable
    setEtdStoreSnapshot alt.takeSnapshot EtdStore
    setIsModalOpen true

  closeModal = ->
    setIsModalOpen false

  cancelDetailedJudgements = ->
    alt.bootstrap etdStoreSnapshot
    closeModal()

  applyDetailedJudgements = ->
    EtdActions.save() unless noAutoSave
    closeModal()

  changeJudgement = (value) ->
    actionName = if noAutoSave then 'changeJudgement' else 'changeAndSaveJudgement'
    EtdActions[actionName] sectionId, value, isConsensus
    onJudgementChange?(sectionId, value, isConsensus)

  handleJudgementChange =(e) ->
    return if readOnly
    changeJudgement e.currentTarget.value

  <React.Fragment>
    {if renderMode is 'preview'
      <div className="criteria-description">
        {criterionDescription}
      </div>
    }
    <RadioButtonList
      additionalOptions={additionalOptions}
      editable={editable}
      name={sectionId}
      onChange={handleJudgementChange}
      options={options}
      sectionId={sectionId}
      sectionName={sectionName}
      selectedOption={selectedOption}
    />
    {if renderMode isnt 'printout'
      <div>
        <Button
          className="btn btn-block detailed-judgements-btn"
          label={if templateId.indexOf('overarching') isnt -1
            i18n "ranking_judgement.judgment"
          else
            i18n "detailed_judgements.name"}
          onClick={openModal}
        />
        <Modal
          className="detailed-judgements"
          isOpen={isModalOpen}
          closeButton={false}
          onClose={closeModal}
          title={i18n 'detailed_judgements.name'}
        >
          <DetailedJudgements
            criterionDescription={criterionDescription}
            criticalOutcomes={criticalOutcomes}
            details={details}
            editable={editable}
            finalJudgementAdditionalOptions={additionalOptions}
            finalJudgementOptions={options}
            finalJudgementSelectedOption={selectedOption}
            isConsensus={isConsensus}
            onApply={applyDetailedJudgements}
            onCancel={cancelDetailedJudgements}
            onFinalJudgementChange={changeJudgement}
            questionType={questionType}
            sectionId={sectionId}
            sectionName={sectionName}
          />
        </Modal>
      </div>
    }
  </React.Fragment>

module.exports = RegularJudgment
